import { format } from 'date-fns';

export const formatDate = (date: string | Date) => {
  if (!date) return;

  if (typeof date === 'string') {
    return format(new Date(date), 'dd/MM/yyyy');
  }

  return format(date, 'dd/MM/yyyy');
};

export const formatDateTime = (date: string) => {
  date = date.split('T')[0];
  const [year, month, day] = date.split('-');

  return `${day}/${month}/${year}`;
};

export const formatBirthdate = (birthdate: string) => {
  const [year, month, day] = birthdate.split('-');

  return `${day}/${month}/${year}`;
};
